import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo/logo-dark-white-text.svg'


const _hoisted_1 = { class: "max-w-2xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8" }
const _hoisted_2 = { class: "relative flex items-center justify-between h-16" }
const _hoisted_3 = { class: "absolute inset-y-0 left-0 flex items-center sm:hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_5 = { class: "flex-1 flex items-center justify-center sm:items-stretch sm:justify-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "flex-shrink-0 flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "block lg:hidden h-8 w-auto",
    src: _imports_0,
    alt: "Link shortener"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "hidden lg:block h-8 w-auto",
    src: _imports_0,
    alt: "Link shortener"
  })
], -1)
const _hoisted_7 = { class: "hidden sm:block sm:ml-6" }
const _hoisted_8 = { class: "flex space-x-4" }
const _hoisted_9 = ["href", "onClick", "aria-current"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0" }, null, -1)
const _hoisted_11 = { class: "px-2 pt-2 pb-3 space-y-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createBlock(_component_Disclosure, {
    as: "nav",
    class: "bg-gray-800"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DisclosureButton, { class: "inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" }, {
              default: _withCtx(() => [
                _hoisted_4,
                (!open)
                  ? (_openBlock(), _createBlock(_component_MenuIcon, {
                      key: 0,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
                  : (_openBlock(), _createBlock(_component_XIcon, {
                      key: 1,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: item.name,
                    href: item.href,
                    onClick: ($event: any) => (_ctx.$emit('navigate', item.href)),
                    class: _normalizeClass([
                  item.current
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                  'px-3 py-2 rounded-md text-sm font-medium', // TODO: Fix ring to be more 'dark mode-like'
                ]),
                    "aria-current": item.current ? 'page' : undefined
                  }, _toDisplayString(item.name), 11, _hoisted_9))
                }), 128))
              ])
            ])
          ]),
          _hoisted_10
        ])
      ]),
      _createVNode(_component_DisclosurePanel, { class: "sm:hidden" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
              return (_openBlock(), _createBlock(_component_DisclosureButton, {
                key: item.name,
                as: "a",
                href: item.href,
                onClick: ($event: any) => (_ctx.$emit('navigate', item.href)),
                class: _normalizeClass([
            item.current
              ? 'bg-gray-900 text-white'
              : 'text-gray-300 hover:bg-gray-700 hover:text-white',
            'block px-3 py-2 rounded-md text-base font-medium',
          ]),
                "aria-current": item.current ? 'page' : undefined
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["href", "onClick", "class", "aria-current"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}